import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { TransportInformation } from '../../../../../shared/objects/transport-information/transport-information';
import { Order } from '../../../../../shared/objects/order/order';
import { CleanType } from '../../../../../shared/objects/enum/cleanType';
import { ModalService } from '../../../../../core/services/modal.service';
import { CommonUtils } from '../../../../../shared/utils/common.utils';
import { ContainerService } from '../../shared/container.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ProductInformation } from '../../../../../shared/objects/transport-information/product-information';
import { ContainerCompartmentComponent } from '../container-compartment/container-compartment.component';
import { NgForm, ReactiveFormsModule } from '@angular/forms';
import { OrderService } from '../../shared/order.service';
import { FormGroup, FormControl } from '@angular/forms';
import { OrderHeaderComponent } from '../../order-header/order-header.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderActuals } from '../../../../../shared/objects/order/order.actuals';
import { TransportInformationTemplate } from '../../../../../shared/objects/transport-information/transport-information-template';
import { PreviousProductField } from '../../../../../shared/objects/enum/previousProductField';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { EquipmentClass } from '../../../../../shared/objects/enum/equipmentClass';
import { CleaningStatus } from '../../../../../shared/objects/enum/cleaningStatus';
import { PreviousProductType } from '../../../../../shared/objects/enum/previousProductType';
import { TruckType } from '../../../../../shared/objects/enum/truckType';
import { OrderNotificationService } from '../../shared/order-notification.service';
import { GenericConfirmationComponent } from '../../../home/components/generic-confirmation/generic-confirmation.component';
import { ConfirmationDialogService } from '../../../../../core/services/confirmation-dialog.service';
import { TransportInformationField } from '../../../../../shared/objects/transport-information/transport-information-field';
import { TransportInfoContainer } from '../../../../../shared/objects/transport-information/transport-information-container';
import { take, startWith, pairwise } from 'rxjs/operators';
import { HashLocationStrategy, Location } from '@angular/common';
import { Country } from '../../../../../shared/objects/order/country';
import { GlobalResponsivenessService } from '../../../../../core/services/global-responsiveness.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Breadcrumb } from '../../../../../shared/objects/breadcrumb/breadcrumb.model';
import { RouteAction } from '../../shared/route-action.enum';
import { BreadcrumbService } from '../../../../../core/services/breadcrumb.service';
import { PageUpdate } from '../../../../../shared/objects/breadcrumb/page-update';
import { AuthService } from '../../../../../core/services/auth.service';

@Component({
    selector: 'app-transport-details',
    templateUrl: './transport-details.component.html',
    styleUrls: ['./transport-details.component.css'],
    standalone: false
})
export class TransportDetailsComponent implements OnInit, OnDestroy {
  order: Order;
  currentTransportInformation: TransportInformation;
  editMode: boolean;
  carrierMustAcceptOrders = false;
  loadDisabled: boolean;
  delivDisabled: boolean;
  template: TransportInformationTemplate;
  transportInfoForm: FormGroup;
  equipmentClass = EquipmentClass;
  cleaningStatus = CleaningStatus;
  previousProductType = PreviousProductType;
  truckType = TruckType;
  compartmentAdded: EventEmitter<boolean> = new EventEmitter<boolean>();
  transportInformation: TransportInformation;
  cleaningOption: CleanType;
  productInformationDataSource: MatTableDataSource<ProductInformation> =
    new MatTableDataSource<ProductInformation>();
  saveTransportInfoInProgress: boolean;
  submitted: boolean;
  transportInformationDisabled = true;
  timeslotCollapsed = false;
  childPopUpShown: boolean;
  formDisabled: boolean;
  templateField = PreviousProductField;
  canAddCompartments = false;
  requireCompartments = false;
  invalidCompartmentInfo = false;
  previousProductsNumber: number;
  isTrailerLicenseUpdated = false;
  isTankLicenseUpdated = false;
  prefixes: Country[];
  driverMobileNumber: string;
  driverMobileNumberPrefix: string;
  isMobile: boolean;
  isTabletPortrait: boolean;
  orderId = '';
  productInformationColumns = [
    'compartment',
    'capacity',
    'previousProduct1',
    'IDTF1',
    'previousProduct2',
    'IDTF2',
    'previousProduct3',
    'IDTF3',
    'actions',
  ];
  transportInformationCollapsed = false;

  isFieldRequired(field: number): boolean {
    let required = false;
    this.template?.fields.forEach(element => {
      if (element.fieldType === field) {
        if (element.available && element.mandatory) {
          required = true;
        }
      }
    });
    return required;
  }

  get CleanType() {
    return CleanType;
  }

  get maxNumberOfCompartmentsReached(): boolean {
    return (
      (!!this.transportInformation?.productInformation &&
        this.transportInformation?.productInformation.length === 8) ||
      !this.canAddCompartments
    );
  }

  private readonly licenseRegex: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);
  public readonly CONTROL_NAME_TRUCK_LICENSE = 'Truck';
  public readonly CONTROL_NAME_SEMITRAILER_LICENSE = 'Trailer';
  public readonly CONTROL_NAME_CONTAINER_NUMBER = 'ContainerNumber';
  public readonly CONTROL_NAME_SCOPA = 'ScopaId';

  subscriptions: Subscription[] = [];
  get EditTransportInfoLabel() {
    return this.translateService.instant(
      'ORDER-LIST-DETAILS.EDIT-TRANSPORT-INFO',
    );
  }
  get SaveTransportInfoLabel() {
    return this.translateService.instant(
      'ORDER-LIST-DETAILS.SAVE-TRANSPORT-INFO',
    );
  }
  get MissingTemplateInfoLabel() {
    return this.translateService.instant(
      'ORDER-LIST-DETAILS.NO-TRANSPORT-INFO-TEMPLATE',
    );
  }
  get isImpersonated() {
    return this.authService.isImpersonated();
  }
  get cannotSaveCompartments(): boolean {
    return (
      this.productInformationDataSource.data.length > 0 &&
      (!this.transportInformation.truckType ||
        this.cannotSaveTrailerCompartments ||
        this.cannotSaveTankContainerCompartments)
    );
  }

  get cannotSaveTrailerCompartments(): boolean {
    return (
      this.transportInformation.truckType == this.truckType.Trailer &&
      this.semiLicensePlaceMissingOrInvalid
    );
  }
  get cannotSaveTankContainerCompartments(): boolean {
    return (
      this.transportInformation.truckType == this.truckType.IsoContainer &&
      this.tcNumberMissingOrInvalid
    );
  }

  get tcNumberMissingOrInvalid(): boolean {
    return (
      (!this.transportInformation.tankContainerLicensePlate ||
        this.transportInfoForm.get(this.CONTROL_NAME_CONTAINER_NUMBER)
          .invalid) &&
      this.isIsoContainer
    );
  }

  get semiLicensePlaceMissingOrInvalid(): boolean {
    return (
      !this.transportInformation.semitrailerLicensePlate ||
      this.transportInfoForm.get(this.CONTROL_NAME_SEMITRAILER_LICENSE).invalid
    );
  }

  get isIsoContainer(): boolean {
    return (
      this.transportInfoForm.get(this.CONTROL_NAME_CONTAINER_NUMBER) &&
      this.transportInformation.truckType == this.truckType.IsoContainer
    );
  }

  public breadcrumbs: Breadcrumb[] = [];

  private nextNavigationRoute = '';
  constructor(
    private modalService: ModalService,
    private orderService: OrderService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private location: Location,
    private router: Router,
    private orderNotificationService: OrderNotificationService,
    private confirmationService: ConfirmationDialogService,
    private globalResponsive: GlobalResponsivenessService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService,
  ) {
    this.transportInfoForm = this.fb.group({});
    this.getPrefixes();
    this.isMobile = this.globalResponsive.getCurrentResolution() == '360x640';
    this.isTabletPortrait =
      this.globalResponsive.getCurrentResolution() == '768x1024';
  }

  ngOnDestroy(): void {
    const pageInfo = {
      id: null,
    };
    this.breadcrumbService.updatePageInfo(pageInfo);

    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.orderId = this.route.snapshot.paramMap.get('id');
    const pageInfo = {
      id: this.orderId,
    };
    this.breadcrumbService.updatePageInfo(pageInfo);
    let state = history.state;
    this.subscriptions.push(
      this.orderService.getOrder(this.orderId.toString()).subscribe(order => {
        this.order = Order.fromObj(order);

        this.currentTransportInformation = order.transportInformation;
        this.carrierMustAcceptOrders = state.carrierMustAcceptOrders;
        this.delivDisabled = true;
        this.loadDisabled = true;
        this.editMode = false;
        this.transportInformationDisabled = !this.editMode;
        this.formDisabled = this.editMode ? null : true;
        this.template = this.order.previousProductTemplate;
        // this.emitTransportInfoEditable();
        this.transportInformation = !this.editMode
          ? this.order.transportInformation ||
            new TransportInformation(+this.order.orderId)
          : this.currentTransportInformation;
        this.transportInformation.productInformation =
          this.transportInformation.productInformation || [];
        this.productInformationDataSource = !!this.transportInformation
          ? new MatTableDataSource<ProductInformation>(
              this.transportInformation.productInformation,
            )
          : new MatTableDataSource<ProductInformation>();

        if (this.productInformationDataSource.data) {
          this.processProductInformation([
            ...this.productInformationDataSource.data,
          ]);
        }
        if (this.template) {
          this.template?.fields.forEach(element => {
            if (element.available) {
              if (!this.isIgnoredField(element.fieldType)) {
                if (
                  element.mandatory &&
                  element.fieldType !== PreviousProductField.PreviousProductType
                ) {
                  this.transportInfoForm.addControl(
                    PreviousProductField[element.fieldType],
                    new FormControl('', Validators.required),
                  );
                } else {
                  this.transportInfoForm.addControl(
                    PreviousProductField[element.fieldType],
                    new FormControl(''),
                  );
                }
              }
              if (
                element.fieldType ===
                PreviousProductField.NumberOfPreviousProducts
              ) {
                this.previousProductsNumber = element.cardinal;
              }
              if (
                element.fieldType === PreviousProductField.PreviousProductType
              ) {
                this.transportInformation.previousProductType =
                  element.cardinal;
              }
              if (
                element.fieldType === PreviousProductField.NumberOfCompartments
              ) {
                this.canAddCompartments = element.available;
                this.requireCompartments = element.mandatory;
              }
            }
          });

          this.setUnknownStatusFields();
          this.onTruckTypeChange();
          this.updatePreviousLicense();
          this.splitMobileNumber();
          this.cd.detectChanges();

          this.transportInfoForm.markAsPristine();
          this.updateForm();
        } else {
          this.cd.markForCheck();
        }
      }),
    );

    this.subscriptions.push(
      this.breadcrumbService.pageChangeSubject$.subscribe(page => {
        if (page === null) {
          this.navigateBack();
        } else {
          this.routeTo(page);
        }
      }),
    );

    this.subscriptions.push(
      this.globalResponsive.isMobile$.subscribe(isMobile => {
        this.isMobile = isMobile;
      }),
    );
    this.subscriptions.push(
      this.globalResponsive.isPortraitTablet$.subscribe(isTabletPortrait => {
        this.isTabletPortrait = isTabletPortrait;
      }),
    );
  }

  get addTooltip(): string {
    return this.translateService.instant('SHARED.ADD-BUTTON');
  }
  get transportInfoI18(): string {
    return this.translateService.instant(
      'ORDER-LIST-DETAILS.TS-TITLE-TRANSP-INFO',
    );
  }

  public navigateBack() {
    if (this.isImpersonated) {
      this.location.back();
      return;
    }

    if (this.transportInfoForm.dirty) {
      this.showDirtyDataWarning(RouteAction.BACK);
    } else {
      this.location.back();
    }
  }

  public routeTo(update: PageUpdate): void {
    if (this.isImpersonated) {
      if (update.isLogout) {
        this.authService.logout();
      }
      this.router.navigate([update.route]);
      return;
    }

    if (this.transportInfoForm.dirty) {
      this.nextNavigationRoute = update.route;
      this.showDirtyDataWarning(RouteAction.MODULE);
    } else {
      if (update.isLogout) {
        this.authService.logout();
      }
      this.router.navigate([update.route]);
    }
  }

  showDirtyDataWarning(routeAction: RouteAction): void {
    const confirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' },
    );
    this.confirmationService.setup(confirmationModalRef, {
      bodyKey: 'ORDER-LIST-DETAILS.MESSAGE-CLOSE-MODAL',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-CLOSE-YES',
      titleKey: 'ORDER-LIST-DETAILS.TITLE-CLOSE-MODAL',
      confirmAction: this.processDirtyEntityWarningOption.bind(
        this,
        routeAction,
      ),
      dismissAction: this.processDismissDirtyEntityWarning.bind(
        this,
        routeAction,
      ),
    });
  }
  private processDirtyEntityWarningOption(answer: RouteAction): void {
    this.modalService.dismissAll('close');
    if (answer === RouteAction.BACK) {
      this.location.back();
    }
    if (answer === RouteAction.MODULE) {
      if (this.nextNavigationRoute === '/login') {
        this.authService.logout();
      }
      this.router.navigate([this.nextNavigationRoute]);
      this.nextNavigationRoute = '';
    }
  }
  private processDismissDirtyEntityWarning(answer: RouteAction): void {
    this.modalService.closeAll();
  }

  updatePreviousLicense() {
    this.subscriptions.push(
      this.transportInfoForm
        .get('ContainerNumber')
        ?.valueChanges.pipe(
          startWith(this.transportInformation.tankContainerLicensePlate),
          pairwise(),
        )
        .subscribe(([prev, next]: [any, any]) => {
          if (prev != next) {
            this.isTankLicenseUpdated = true;
          }
        }),
    );
    this.subscriptions.push(
      this.transportInfoForm
        .get('Trailer')
        ?.valueChanges.pipe(
          startWith(this.transportInformation.semitrailerLicensePlate),
          pairwise(),
        )
        .subscribe(([prev, next]: [any, any]) => {
          if (prev != next) {
            this.isTrailerLicenseUpdated = true;
          }
        }),
    );
  }

  isIgnoredField(fieldType: number) {
    if (
      fieldType === PreviousProductField.Unknown ||
      fieldType === PreviousProductField.NumberOfCompartments ||
      fieldType === PreviousProductField.SizeOfCompartments ||
      fieldType === PreviousProductField.NumberOfPreviousProducts ||
      fieldType === PreviousProductField.IDTF
    ) {
      return true;
    }
    return false;
  }

  formPrefix(prefix: string, code: string) {
    return code + ' (' + prefix + ')';
  }

  setUnknownStatusFields() {
    if (!this.transportInformation.truckType) {
      this.transportInformation.truckType = this.isFieldRequired(
        PreviousProductField.TruckType,
      )
        ? null
        : TruckType.Unknown;
    }
    if (!this.transportInformation.equipmentClass) {
      this.transportInformation.equipmentClass = this.isFieldRequired(
        PreviousProductField.EquipmentClass,
      )
        ? null
        : EquipmentClass.Unknown;
    }
    if (!this.transportInformation.cleaningStatus) {
      this.transportInformation.cleaningStatus = this.isFieldRequired(
        PreviousProductField.CleaningStatus,
      )
        ? null
        : CleaningStatus.Unknown;
    }
  }

  setFieldRequired(field: string) {
    const formField = this.transportInfoForm.get(field);
    if (formField) {
      this.removeErrors(formField);
      formField.setValidators(Validators.required);
      formField.markAsDirty();
      formField.markAsTouched();
      formField.updateValueAndValidity();
    }
  }

  clearField(field: string) {
    const formField = this.transportInfoForm.get(field);
    if (formField) {
      formField.clearValidators();
      this.removeErrors(formField);
      formField.setValue(null);
      formField.updateValueAndValidity();
    }
  }

  removeErrors(formField) {
    formField.setErrors(null);
  }

  updateForm() {
    this.transportInfoForm.updateValueAndValidity();
  }

  onTruckTypeChange() {
    this.subscriptions.push(
      this.transportInfoForm
        .get('TruckType')
        ?.valueChanges.subscribe((type: TruckType) => {
          if (TruckType[type] === TruckType[TruckType.Trailer]) {
            this.clearField('ContainerNumber');
            this.setFieldRequired('Trailer');
          } else if (TruckType[type] === TruckType[TruckType.IsoContainer]) {
            this.clearField('Trailer');
            this.setFieldRequired('ContainerNumber');
          } else {
            this.clearField('ContainerNumber');
            this.clearField('Trailer');
          }

          this.cd.detectChanges();
        }),
    );
  }

  addNewCompartment() {
    const compartmentModalRef = this.modalService.open(
      ContainerCompartmentComponent,
      { centered: true, container: '#AppContent', backdrop: 'static' },
    );

    compartmentModalRef.componentInstance.editMode = false;
    compartmentModalRef.componentInstance.template = this.template;
    compartmentModalRef.componentInstance.nextCompartmentNumber =
      this.getNextCompartmentNumber();
    compartmentModalRef.result.then(res => {
      if (res) {
        this.processProductInformation([
          ...this.productInformationDataSource.data,
          res,
        ]);

        this.transportInfoForm.markAsDirty();
      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
      this.cd.detectChanges();
    });
  }

  editCompartment(compartment: ProductInformation) {
    const compartmentModalRef = this.modalService.open(
      ContainerCompartmentComponent,
      { centered: true, container: '#AppContent', backdrop: 'static' },
    );
    compartmentModalRef.componentInstance.editMode = true;
    compartmentModalRef.componentInstance.compartment = { ...compartment };
    compartmentModalRef.componentInstance.template = this.template;
    compartmentModalRef.result.then(res => {
      if (res) {
        const oldCompartmentIndex =
          this.productInformationDataSource.data.findIndex(
            compartment =>
              compartment.compartmentNumber == res.compartmentNumber,
          );

        const newCompartment = {
          ...this.productInformationDataSource.data[oldCompartmentIndex],
          ...res,
        };
        this.productInformationDataSource.data[oldCompartmentIndex] =
          newCompartment;

        this.processProductInformation([
          ...this.productInformationDataSource.data,
        ]);
        this.transportInfoForm.markAsDirty();
      }
      this.cd.detectChanges();
    });
  }

  deleteCompartment(compartment: ProductInformation) {
    const confirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' },
    );
    this.confirmationService.setup(confirmationModalRef, {
      titleKey: 'SHARED.WARNING-CONFIRMATION-REQUIRED',
      okButtonKey: 'SHARED.WARNING-CONFIRM-TEXT',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      bodyKey: 'COMPARTMENT-DETAILS.DELETE-QUESTION',
      contextValue: compartment.compartmentNumber,
      confirmAction: this.processDeleteConfirmationAnswer.bind(
        this,
        compartment,
      ),
      dismissAction: this.processDeleteCancellationAnswer.bind(this),
    });
    this.toggleFade();
  }

  private processDeleteConfirmationAnswer(compartment: ProductInformation) {
    const filteredCompartments = this.productInformationDataSource.data.filter(
      comp => comp.compartmentNumber != compartment.compartmentNumber,
    );
    this.processProductInformation([...filteredCompartments]);
    this.cd.detectChanges();
    this.closeContextModal();
    this.toggleFade();
  }

  private processDeleteCancellationAnswer() {
    this.closeContextModal();
    this.toggleFade();
  }

  setCompartmentInfoValidity() {
    this.invalidCompartmentInfo = true;
  }

  public onPaste(event, formControlName: string): void {
    const clipboardData = event.clipboardData;
    const pastedText: string = clipboardData.getData('text');

    const res = pastedText.match(this.licenseRegex);
    if (res === null) {
      this.transportInfoForm.get(formControlName).reset();
      event.preventDefault();
    }
  }

  public onChange(formControlName: string): void {
    const val: string = this.transportInfoForm.get(formControlName).value;
    const res = val.match(this.licenseRegex);
    if (res === null) {
      this.transportInfoForm.get(formControlName).reset();
    }
  }

  isCompartmentInfoValid() {
    this.invalidCompartmentInfo = false;
    for (let compartment of this.transportInformation.productInformation) {
      switch (this.previousProductsNumber) {
        case 1: {
          if (
            (!compartment.idtF1 &&
              this.isFieldRequired(PreviousProductField.IDTF)) ||
            (!compartment.previousProduct1 &&
              this.isFieldRequired(
                PreviousProductField.NumberOfPreviousProducts,
              ))
          ) {
            this.setCompartmentInfoValidity();
            return false;
          }
          break;
        }
        case 2: {
          if (
            ((!compartment.idtF1 || !compartment.idtF2) &&
              this.isFieldRequired(PreviousProductField.IDTF)) ||
            ((!compartment.previousProduct1 || !compartment.previousProduct2) &&
              this.isFieldRequired(
                PreviousProductField.NumberOfPreviousProducts,
              ))
          ) {
            this.setCompartmentInfoValidity();
            return false;
          }
          break;
        }
        case 3: {
          if (
            ((!compartment.idtF1 || !compartment.idtF2 || !compartment.idtF3) &&
              this.isFieldRequired(PreviousProductField.IDTF)) ||
            ((!compartment.previousProduct1 ||
              !compartment.previousProduct2 ||
              !compartment.previousProduct3) &&
              this.isFieldRequired(
                PreviousProductField.NumberOfPreviousProducts,
              ))
          ) {
            this.setCompartmentInfoValidity();
            return false;
          }
          break;
        }
        default: {
          if (
            this.isFieldRequired(PreviousProductField.IDTF) ||
            this.isFieldRequired(PreviousProductField.NumberOfPreviousProducts)
          ) {
            this.setCompartmentInfoValidity();
            return false;
          }
          break;
        }
      }
    }
    return true;
  }

  saveMobileNumber() {
    if (!this.driverMobileNumberPrefix && !this.driverMobileNumber) {
      this.transportInformation.driverMobileNumber = null;
    } else if (!this.driverMobileNumberPrefix) {
      this.transportInformation.driverMobileNumber = this.driverMobileNumber;
    } else {
      this.transportInformation.driverMobileNumber =
        this.driverMobileNumberPrefix + ' ' + this.driverMobileNumber;
    }
  }

  splitMobileNumber() {
    let mobileNumber = this.transportInformation.driverMobileNumber;
    if (mobileNumber) {
      if (mobileNumber.indexOf(' ') > 0) {
        let numbers = mobileNumber.split(' ');
        this.driverMobileNumberPrefix = numbers[0];
        this.driverMobileNumber = numbers[1];
      } else {
        this.driverMobileNumber = mobileNumber;
      }
    }
  }

  isMobileNumberValid() {
    if (!this.driverMobileNumberPrefix && !this.driverMobileNumber) return true;
    if (
      this.transportInfoForm.get('PrefixNumber') &&
      this.transportInfoForm.get('MobileNumber') &&
      !this.driverMobileNumber
    )
      return false;
    return true;
  }

  markFormTouched(form: any) {
    CommonUtils.markFormAsTouched(form);
    this.submitted = true;
  }

  submitTransportInformation(transportInfoForm: any): void {
    if (!this.isMobileNumberValid()) {
      this.markFormTouched(transportInfoForm);
      if (this.driverMobileNumberPrefix) {
        this.transportInfoForm
          .get('MobileNumber')
          .setErrors({ incorrect: true });
      }
      return;
    }

    if (
      !transportInfoForm.valid ||
      (this.requireCompartments &&
        this.transportInformation.productInformation.length === 0) ||
      !this.isCompartmentInfoValid()
    ) {
      this.markFormTouched(transportInfoForm);
      return;
    }
    this.saveMobileNumber();
    this.saveTransportInfoInProgress = true;
    this.orderService
      .postTransportInformation(this.transportInformation)
      .subscribe(
        ti => {
          this.toggleTransportInformation();
          this.transportInformation = ti;
          this.transportInformation.productInformation =
            this.transportInformation.productInformation || [];
          this.submitted = false;
          this.saveTransportInfoInProgress = false;
          this.orderNotificationService.showTransportInformationSavedMessage();

          this.cd.detectChanges();
          this.transportInfoForm.markAsPristine();
          this.updateForm();
        },
        error => {
          this.submitted = false;
          this.saveTransportInfoInProgress = false;
          this.orderNotificationService.showTransportInformationNotSavedMessageFailure();
          this.cd.markForCheck();
        },
      );
    this.cd.detectChanges();
  }

  scrollToBottom() {
    const compartments = document.getElementById('product-registration');
    if (!this.showCompartmentsAsCards()) {
      compartments.scrollTop = compartments.scrollHeight;
    }
  }

  openCompartmentPanel(panel: Element) {
    var element = document.getElementById(panel.id);
    setTimeout(() => {
      element.scrollIntoView({ block: 'nearest' });
    }, 250);
  }

  showCompartmentsAsCards() {
    return this.isMobile || this.isTabletPortrait;
  }

  toggleTransportInformation(): void {
    this.transportInformationDisabled = !this.transportInformationDisabled;
    this.formDisabled ? (this.formDisabled = null) : (this.formDisabled = true);
    // this.emitTransportInfoEditable();
  }

  private getNextCompartmentNumber(): number {
    return this.productInformationDataSource.data.length + 1;
  }

  private getCompartmentsOrdered(
    compartments: ProductInformation[] = [],
  ): ProductInformation[] {
    let compartmentNumber = 1;
    compartments.sort((c1, c2) => c1.compartmentNumber - c2.compartmentNumber);
    compartments.forEach(compartment => {
      compartment.compartmentNumber = compartmentNumber;
      compartmentNumber++;
    });
    return compartments;
  }

  private processProductInformation(productInfos: ProductInformation[]) {
    this.productInformationDataSource = new MatTableDataSource([
      ...productInfos,
    ]);
    this.transportInformation.productInformation = this.getCompartmentsOrdered(
      this.productInformationDataSource.data,
    );
  }

  // private emitCurrentTransportInfo(): void {
  //   this.currentTransportInfo.next(this.transportInformation);
  // }

  // private emitTransportInfoEditable(): void {
  //   this.transportInformationEditable.next(this.transportInformationDisabled);
  // }

  private closeContextModal(): void {
    this.modalService.close();
  }

  uploadCompartments() {
    let containerData = this.transportInformation.productInformation.length;
    if (
      TruckType[this.transportInformation.truckType] ===
        TruckType[TruckType.Trailer] &&
      this.transportInfoForm.get('Trailer').valid
    ) {
      if (!this.isTrailerLicenseUpdated && containerData > 0) {
        return;
      }
      this.getContainer(
        this.transportInformation.semitrailerLicensePlate,
        TruckType.Trailer,
      );
      this.isTrailerLicenseUpdated = false;
    } else {
      if (
        TruckType[this.transportInformation.truckType] ===
          TruckType[TruckType.IsoContainer] &&
        this.transportInfoForm.get('ContainerNumber').valid
      ) {
        if (!this.isTankLicenseUpdated && containerData > 0) {
          return;
        }
        this.getContainer(
          this.transportInformation.tankContainerLicensePlate,
          TruckType.IsoContainer,
        );
        this.isTankLicenseUpdated = false;
      }
    }
  }

  getPrefixes() {
    this.orderService.getCountries().then(value => {
      this.prefixes = value.filter(element => element.prefix);
    });
  }

  getContainer(licensePlate: string, truckType: TruckType) {
    this.orderService
      .getContainer(licensePlate, truckType, this.transportInformation.id)
      .subscribe(
        (c: TransportInfoContainer) => {
          if (c) {
            this.processProductInformation([...c.compartments]);
            this.cd.detectChanges();
          }
        },
        error => {},
      );
  }

  closeTransportInformationDetails() {
    if (!this.transportInformationDisabled) {
      this.saveMobileNumber();
      this.reopen();
      const confirmationModalRef = this.modalService.open(
        GenericConfirmationComponent,
        { size: 'lg', container: '#AppContent' },
      );
      this.confirmationService.setup(confirmationModalRef, {
        bodyKey: 'SHARED.WARNING-CLOSE-TEXT',
        cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
        okButtonKey: 'SHARED.WARNING-CLOSE-YES',
        titleKey: 'SHARED.WARNING-CLOSE-TITLE',
        confirmAction: this.processConfirmDiscard.bind(this),
        dismissAction: this.processCancelDiscard.bind(this),
      });
    } else {
      // this.modalRefItself.close();
    }
  }

  private async processConfirmDiscard(): Promise<void> {
    this.modalService.closeAll();
  }

  private async processCancelDiscard(): Promise<void> {
    this.closeContextModal();
  }

  private reopen(): void {
    const transportInfoModalRef = this.modalService.open(
      TransportDetailsComponent,
      { windowClass: 'modal-xxl', container: '#AppContent' },
    );

    transportInfoModalRef.componentInstance.order = this.order;

    transportInfoModalRef.componentInstance.currentTransportInformation =
      this.transportInformation;
    transportInfoModalRef.componentInstance.carrierMustAcceptOrders =
      this.carrierMustAcceptOrders;
    transportInfoModalRef.componentInstance.modalRefItself =
      transportInfoModalRef;
    transportInfoModalRef.componentInstance.delivDisabled = true;
    transportInfoModalRef.componentInstance.loadDisabled = true;
    transportInfoModalRef.componentInstance.editMode =
      !this.transportInformationDisabled;
    transportInfoModalRef.result.then(
      result => {
        // this.ordersListRef.refreshOrderList();
        this.closeContextModal();
      },
      reason => {
        // this.ordersListRef.refreshOrderList();
        this.closeContextModal();
      },
    );
  }

  toggleFade(): void {
    this.childPopUpShown = !this.childPopUpShown;
  }

  refreshOrder(): void {
    if (!this.loadDisabled || !this.delivDisabled) {
      return;
    }
    this.orderService.getOrder(this.order.orderId).subscribe(order => {
      this.order = Order.fromObj(order);
      this.order = this.orderService.setupOrdersDetails([order], this.cd)[0];
    });
  }

  updateChangedOrder(): void {
    this.refreshOrder();
  }
}
